import React from "react";

const ComboFiltro = ({ label, value, onChange, name, options }) => {
  return (
    <div className="form-group">
      <label>{label}</label>
      <select name={name} value={value} onChange={onChange}>
        <option value="">-- Todos --</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ComboFiltro;
